import { MatTableDataSource } from '@angular/material/table';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Drug } from '../../models/drug';
import { RpoToolService } from '../../services/rpo-tool.service';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as constants from 'src/app/config/app-constants';
import { ImportWizardSearchDrugComponent } from '../import-wizard-search-drug/import-wizard-search-drug.component';
import { routePaths } from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { ImportWizardDrugDetailsComponent } from '../import-wizard-drug-details/import-wizard-drug-details.component';
@Component({
    selector: 'app-search-drug-list',
    templateUrl: './search-drug-list.component.html',
    styleUrls: ['./search-drug-list.component.scss'],
    standalone: false
})
export class SearchDrugListComponent implements OnInit, OnChanges {
  displayedColumns = ['name', 'ndc', 'countryCode','source', 'system', 'strength', 'manufacturer', 'priority', 'modifiedBy' ,'requestor', 'age','action'];
  selectedRow:any;
  dataSource= new MatTableDataSource<Drug>();
  @Input() dataSourceId:number = 0;
  @Input() searchText: any = '';
  @Input()  permanentQuarantine = false;
  @Input() countryId:number = 0;
  @Output() countUpdated: EventEmitter<number> = new EventEmitter<number>();
  @Input() selectedSearchCriteria: any;
  @Input() modifiedBy: any = '';
    //#region Pagination properties
    totalRows: number = 0;
    currentPage: number = 1;
    pageSize: number = 5;
    pageSizeOptions: number[] = [5, 10, 20, 40, 50];
    //#endregion
  private hasInitialized: boolean = false;

  constructor(
    private rpoService: RpoToolService,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    private route: Router,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getDrugData();
    this.hasInitialized = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.hasInitialized) {
      return;
    }

    const shouldRefresh =
      !!changes['dataSourceId'] ||
      !!changes['searchText'] ||
      !!changes['countryId'] ||
      !!changes['selectedSearchCriteria'] ||
      !!changes['modifiedBy'];

    if (shouldRefresh) {
      this.currentPage = 1;
      this.getDrugData();
    }
  }

  handleInputChange(dataSourceId:number,searchText:any, countryId:number, permanentQuarantine:boolean){
    this.dataSourceId=dataSourceId;
    this.searchText = searchText;
    this.countryId = countryId;
    this.permanentQuarantine = permanentQuarantine
    if(searchText.length>0){

    }
    else{
      this.dataSource = new MatTableDataSource<Drug>();
    }


}
redirectToDetailsPage(rowId:any,dataSourceId:number){
  this.route.navigate([`/${routePaths.DRUG_MANAGEMENT}/drug-details`, rowId,dataSourceId,'']);
}
openImportWizardSearchDrug() {

  const dialogRef = this.dialog.open(ImportWizardSearchDrugComponent, {
    backdropClass: ['lgDialog'],
    disableClose: true,
    data: {
      dataSourceId:this.dataSourceId,
      searchText: this.searchText,
      countryId:this.countryId,
      selectedSearchCriteria: this.selectedSearchCriteria
    }
  });

}
  getDrugData(){
    const searchText = this.searchText ?? '';
    let searchKey = 'searchKey'
    this.ngxLoader.start(searchKey);
    this.rpoService.getSearchDrugDataV1(
      this.dataSourceId,
      searchText,
      this.selectedSearchCriteria,
      this.countryId,
      this.modifiedBy,
      this.currentPage ?? 1,
      this.pageSize

    ).subscribe((result)=>{

      this.dataSource.data = result.data.drugs;
      this.currentPage = result.data.currentPage
      this.totalRows = result.data.totalRows
      this.countUpdated.emit(this.totalRows);
      this.ngxLoader.stop(searchKey);
    },
    (error: HttpErrorResponse) => {
      this.ngxLoader.stop(searchKey);
      this.toastService.openToast(
        error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }

  openDrugDetailsImportWizard(drugId:string, dataSourceId:number) {
  
      const dialogRef = this.dialog.open(ImportWizardDrugDetailsComponent, {
        backdropClass: ['lgDialog'],
        disableClose: true,
        autoFocus: false,
        data: {
          ndc: drugId,
          dataSourceId: dataSourceId,
          caseNo: '',
        }
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result.data) {
          //this.getDrugByndc();
        } else {
          console.log("not export", result);
        }
      });
    }


}
